"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */

var QuestionIcon = function QuestionIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "board",
    transform: "translate(-371.000000, -19343.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "group-5b-5",
    transform: "translate(343.000000, 19315.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "question_circle_l",
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "0",
    width: "28",
    height: "28"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14,0 C21.7319865,0 28,6.2680135 28,14 C28,21.7319865 21.7319865,28 14,28 C6.2680135,28 0,21.7319865 0,14 C0,6.2680135 6.2680135,0 14,0 Z M14,2.33333333 C7.55667792,2.33333333 2.33333333,7.55667792 2.33333333,14 C2.33333333,20.4433221 7.55667792,25.6666667 14,25.6666667 C20.4433221,25.6666667 25.6666667,20.4433221 25.6666667,14 C25.6666667,7.55667792 20.4433221,2.33333333 14,2.33333333 Z M14.6666667,18.6666667 C14.942809,18.6666667 15.1666667,18.8905243 15.1666667,19.1666667 L15.1666667,20.5 C15.1666667,20.7761424 14.942809,21 14.6666667,21 L13.3333333,21 C13.057191,21 12.8333333,20.7761424 12.8333333,20.5 L12.8333333,19.1666667 C12.8333333,18.8905243 13.057191,18.6666667 13.3333333,18.6666667 L14.6666667,18.6666667 Z M14,7 C16.5350743,7 18.6666667,8.77632697 18.6666667,11.0833333 C18.6666667,12.9925096 17.7883555,13.9252167 15.1666667,15.2974333 L15.1666667,16.4166667 C15.1666667,16.692809 14.942809,16.9166667 14.6666667,16.9166667 L13.3333333,16.9166667 C13.057191,16.9166667 12.8333333,16.692809 12.8333333,16.4166667 L12.8333333,13.8622937 L13.4782508,13.5398349 C15.8433869,12.3572669 16.3333333,11.9139526 16.3333333,11.0833333 C16.3333333,10.1686787 15.3309189,9.33333333 14,9.33333333 C12.6690811,9.33333333 11.6666667,10.1686787 11.6666667,11.0833333 L11.6666667,11.1666667 C11.6666667,11.442809 11.442809,11.6666667 11.1666667,11.6666667 L9.83333333,11.6666667 C9.55719096,11.6666667 9.33333333,11.442809 9.33333333,11.1666667 L9.33333333,11.0833333 C9.33333333,8.77632697 11.4649257,7 14,7 Z",
    id: "shape_conbine",
    fill: "currentColor"
  }))))));
};
var _default = exports["default"] = QuestionIcon;